import React, {  useState, useEffect, useMemo } from 'react';
import Modal from "react-modal";
import { graphql, Link, navigate  } from "gatsby"
import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"
import {useLocation } from '@reach/router';
import { Disclosure } from '@headlessui/react'
import { ChevronUpIcon } from '@heroicons/react/20/solid'
import { Helmet } from 'react-helmet'
import { Swiper, SwiperSlide} from 'swiper/react';
import {  Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
  
export default ({ data }) => {

  const addDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'pagetype': `category`,
    });
    console.log("DataLayer:", window.dataLayer);
    
  };
  
  
  <Helmet>
  {`
    ${addDataLayer.toString()}
    
  `}
  </Helmet>


const [isVisible, setIsVisible] = useState(false);

// Functie om de state te toggelen
const toggleVisibility = () => {
  setIsVisible(!isVisible);
};



const [modalOpen, setModalOpen] = useState(false);

const location = useLocation();
const urlParams = new URLSearchParams(location.search);

// const destinations = urlParams.getAll('land') || ['frankrijk', 'spanje'];

const urlDestinations = urlParams.getAll('land');
const defaultDestinations = urlDestinations.length > 0 ? urlDestinations : ['frankrijk', 'spanje','portugal','marokko','zuid-afrika','ecuador','nicaragua','mexico','indonesie','sri lanka','costa rica'];
const [selectedDestinations, setSelectedDestinations] = useState(defaultDestinations);

const urlCategories = urlParams.getAll('cat');
const defaultCats = urlCategories.length > 0 ? urlCategories : ['adults', 'family', 'juniors'];
const [selectedCats, setSelectedCats] = useState(defaultCats);


const urlTypes = urlParams.getAll('type');
const defaultTypes = urlTypes.length > 0 ? urlTypes : ['solo', 'friends', 'couple','family'];
const [selectedTypes, setSelectedTypes] = useState(defaultTypes);

const urlSeasons = urlParams.getAll('season');
const defaultSeasons = urlSeasons.length > 0 ? urlSeasons : ['winter', 'spring','summer','autumn'];
const [selectedSeasons, setSelectedSeasons] = useState(defaultSeasons);


const urlThemes = urlParams.getAll('theme');
const defaultThemes = urlThemes.length > 0 ? urlThemes : ['yoga', 'kite','bus','coworking','glamping','surfcamp','surflodge','language'];
const [selectedThemes, setSelectedThemes] = useState(defaultThemes);


useEffect(() => {
  // Update state based on URL parameter changes
  setSelectedDestinations(defaultDestinations);
}, [defaultDestinations]);


useEffect(() => {
  // Update state based on URL parameter changes for 'cat'
  setSelectedCats(defaultCats);
}, [defaultCats]);

useEffect(() => {
  // Update state based on URL parameter changes for 'cat'
  setSelectedTypes(defaultTypes);
}, [defaultTypes]);


useEffect(() => {
  // Update state based on URL parameter changes for 'cat'
  setSelectedSeasons(defaultSeasons);
}, [defaultSeasons]);


useEffect(() => {
  // Update state based on URL parameter changes for 'cat'
  setSelectedThemes(defaultThemes);
}, [defaultThemes]);



  const handleCheckboxChange = (land) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
  
    // Toggle the checkbox state
    if (params.has('land')) {
      const existingLands = params.getAll('land');
      const updatedLands = existingLands.includes(land)
        ? existingLands.filter((l) => l !== land)
        : [...existingLands, land];
  
      params.delete('land');
      updatedLands.forEach((updatedLand) => params.append('land', updatedLand));
    } else {
      params.append('land', land);
    }
  
    // Update the URL with the new parameters
    navigate(`${url.pathname}?${params.toString()}`);
  };


  const handleCatCheckboxChange = (cat) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
  
    // Toggle the checkbox state
    if (params.has('cat')) {
      const existingCats = params.getAll('cat');
      const updatedCats = existingCats.includes(cat)
        ? existingCats.filter((c) => c !== cat)
        : [...existingCats, cat];
  
      params.delete('cat');
      updatedCats.forEach((updatedCat) => params.append('cat', updatedCat));
    } else {
      params.append('cat', cat);
    }
 
    // Update the URL with the new parameters
 navigate(`${url.pathname}?${params.toString()}`);
};


    const handleTypeCheckboxChange = (type) => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
    
      // Toggle the checkbox state
      if (params.has('type')) {
        const existingTypes = params.getAll('type');
        const updatedTypes = existingTypes.includes(type)
          ? existingTypes.filter((c) => c !== type)
          : [...existingTypes, type];
    
        params.delete('type');
        updatedTypes.forEach((updatedType) => params.append('type', updatedType));
      } else {
        params.append('type', type);
      }
  
    // Update the URL with the new parameters
    navigate(`${url.pathname}?${params.toString()}`);

    }

    
    const handleSeasonCheckboxChange = (season) => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
    
      // Toggle the checkbox state
      if (params.has('season')) {
        const existingSeasons = params.getAll('season');
        const updatedSeasons = existingSeasons.includes(season)
          ? existingSeasons.filter((c) => c !== season)
          : [...existingSeasons, season];
    
        params.delete('season');
        updatedSeasons.forEach((updatedSeason) => params.append('season', updatedSeason));
      } else {
        params.append('season', season);
      }
   
    // Update the URL with the new parameters
    navigate(`${url.pathname}?${params.toString()}`);

  };
  

  const handleThemeCheckboxChange = (theme) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
  
    // Toggle the checkbox state
    if (params.has('theme')) {
      const existingThemes = params.getAll('theme');
      const updatedThemes = existingThemes.includes(theme)
        ? existingThemes.filter((c) => c !== theme)
        : [...existingThemes, theme];
  
      params.delete('theme');
      updatedThemes.forEach((updatedTheme) => params.append('theme', updatedTheme));
    } else {
      params.append('theme', theme);
    }
 
  // Update the URL with the new parameters
  navigate(`${url.pathname}?${params.toString()}`);

};



const filteredAndSortedNodes = data.allWpSurfvakantie.edges
  .filter(({ node }) =>
    (selectedDestinations.length > 0
      ? selectedDestinations.includes(node.surfvakantieNieuw.land.toLowerCase())
      : defaultDestinations.includes(node.surfvakantieNieuw.land.toLowerCase())) &&
    (selectedCats.length > 0
      ? selectedCats.some(cat => node.surfvakantieNieuw.categories.includes(cat))
      : defaultCats.some(cat => node.surfvakantieNieuw.categories.includes(cat))) &&
    (selectedTypes.length > 0
      ? selectedTypes.some(type => node.surfvakantieNieuw.categories.includes(type))
      : defaultTypes.some(type => node.surfvakantieNieuw.categories.includes(type))) &&
    (selectedSeasons.length > 0
      ? selectedSeasons.some(season => node.surfvakantieNieuw.categories.includes(season))
      : defaultSeasons.some(season => node.surfvakantieNieuw.categories.includes(season))) &&
    (selectedThemes.length > 0
      ? selectedThemes.some(theme => node.surfvakantieNieuw.categories.includes(theme))
      : defaultThemes.some(theme => node.surfvakantieNieuw.categories.includes(theme)))
  )
  .sort((a, b) => {
    const orderA = a.node.surfvakantieNieuw.customOrder || 0;
    const orderB = b.node.surfvakantieNieuw.customOrder || 0;
    return orderA - orderB;
  });






const [queryVariable, setQueryVariable] = useState('');

const [queryVariables, setQueryVariables] = useState([]);
useEffect(() => {
  const searchParams = new URLSearchParams(location.search);

  // Extract all values for the 'land' parameter
  const lands = searchParams.getAll('land');

  // Update the state with the query variable values
  setQueryVariables(lands);
}, [location.search]);





  return (

    <Layout>
  <link rel="preconnect" href="https://fonts.gstatic.com" />
        
        <SEO 
        title="SurfaWhile Surfvakanties Peniche en Baleal, Portugal" 
        description="Uniek aanbod surfvakanties in Peniche en Baleal, met zorg samengesteld door ons team"
        />
        
    <div className="bg-stone-100 w-full">
    <div className="container mx-auto px-4 py-5">
      <div className="breadcrumbs font-inter text-sm py-2 text-slate-400 font-semibold">
        <Link className="text-slate-400" to="/">Home</Link> &gt; <Link className="text-slate-400" to="/surfvakanties">Surfvakanties</Link> &gt; <Link className="text-slate-400" to="/surfvakanties/portugal">Portugal</Link> &gt; <span className="text-slate-800">Surfvakanties Peniche &amp; Baleal</span>
    </div>
    

    <div id="desktop-filter" className="flex flex-col lg:flex-row my-3">
    
    <div className="hidden lg:inline w-1/4">

    <div className="w-full px-4 pt-4">
      <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2 sticky top-0"> 
        
        
        <Disclosure as="div" className="mt-2" defaultOpen>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-100 px-4 py-2 text-left text-sm font-medium text-slate-900 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
              <h4 className="font-oswald uppercase font-bold mt-2">Doelgroep</h4>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-7 w-7 mt-1 text-black font-bold`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4 text-md text-gray-500">
              <ul className="font-inter list-none">
          <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("adults")}
          onChange={() => handleCatCheckboxChange("adults")}
        />
        <span className="ml-2 font-semibold">Volwassenen</span>
        </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("family")}
          onChange={() => handleCatCheckboxChange("family")}
        />
        <span className="ml-2 font-semibold">Families</span>
        </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("juniors")}
          onChange={() => handleCatCheckboxChange("juniors")}
        />
        <span className="ml-2 font-semibold">Jongeren</span>
        </label>
            </li>
               
        </ul>
        </Disclosure.Panel>
            </>
          )}
        </Disclosure>




        <Disclosure as="div" className="mt-2" defaultOpen>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-100 px-4 py-2 text-left text-sm font-medium text-slate-900 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
              <h4 className="font-oswald uppercase font-bold mt-2">Type reiziger</h4>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-7 w-7 mt-1 text-black font-bold`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4 text-md text-gray-500">
              <ul className="font-inter list-none">
          <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("solo")}
          onChange={() => handleTypeCheckboxChange("solo")}
        />
        <span className="ml-2 font-semibold">Solo-Reizigers</span>
        </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("friends")}
          onChange={() => handleTypeCheckboxChange("friends")}
        />
        <span className="ml-2 font-semibold">Vrienden/vriendinnen</span>
        </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("couple")}
          onChange={() => handleTypeCheckboxChange("couple")}
        />
        <span className="ml-2 font-semibold">Koppels</span>
        </label>
            </li>
         
                     
        </ul>
        </Disclosure.Panel>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="mt-2" defaultOpen>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-100 px-4 py-2 text-left text-sm font-medium text-slate-900 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
              <h4 className="font-oswald uppercase font-bold mt-2">Seizoen</h4>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-7 w-7 mt-1 text-black font-bold`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4 text-sm text-gray-500">
              <ul className="font-inter list-none">


            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("spring")}
          onChange={() => handleSeasonCheckboxChange("spring")}
        />
        <span className="ml-2 font-semibold">Voorjaar</span>
        </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("summer")}
          onChange={() => handleSeasonCheckboxChange("summer")}
        />
        <span className="ml-2 font-semibold">Zomer</span>
        </label>
            </li>


            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("autumn")}
          onChange={() => handleSeasonCheckboxChange("autumn")}
        />
        <span className="ml-2 font-semibold">Herfst</span>
        </label>
            </li>


            {/* <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("winter")}
          onChange={() => handleSeasonCheckboxChange("winter")}
        />
        <span className="ml-2 font-bold">Winter</span>
        </label>
            </li> */}
         
                     
        </ul>
        </Disclosure.Panel>
            </>
          )}
        </Disclosure>




        <Disclosure as="div" className="mt-2" defaultOpen>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-100 px-4 py-2 text-left text-sm font-medium text-slate-900 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
              <h4 className="font-oswald uppercase font-bold mt-2">Thema</h4>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-7 w-7 mt-1 text-black font-bold`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4 text-md text-gray-500">
              <ul className="font-inter list-none">


            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("yoga")}
          onChange={() => handleThemeCheckboxChange("yoga")}
        />
        <span className="ml-2 font-semibold">Surf &amp; Yoga</span>
        </label>
            </li>

            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("language")}
          onChange={() => handleThemeCheckboxChange("language")}
        />
        <span className="ml-2 font-semibold">Surf &amp; Taal</span>
        </label>
            </li>


            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("bus")}
          onChange={() => handleThemeCheckboxChange("bus")}
        />
        <span className="ml-2 font-semibold">Busreizen</span>
        </label>
            </li>


            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("kite")}
          onChange={() => handleThemeCheckboxChange("kite")}
        />
        <span className="ml-2 font-semibold">Kitesurfen</span>
        </label>
            </li>


            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("coworking")}
          onChange={() => handleThemeCheckboxChange("coworking")}
        />
        <span className="ml-2 font-semibold">Coworking</span>
        </label>
            </li>

            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("glamping")}
          onChange={() => handleThemeCheckboxChange("glamping")}
        />
        <span className="ml-2 font-semibold">Glamping</span>
        </label>
            </li>

            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("surfcamp")}
          onChange={() => handleThemeCheckboxChange("surfcamp")}
        />
        <span className="ml-2 font-semibold">Surfcamp</span>
        </label>
            </li>

            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("surflodge")}
          onChange={() => handleThemeCheckboxChange("surflodge")}
        />
        <span className="ml-2 font-semibold">Surflodge</span>
        </label>
            </li>
         
                     
        </ul>
        </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        
      </div>
    </div>
    <p className="my-2">
      <Link className="font-inter font-semibold text-sm hover:underline bg-stone-100 text-black px-5 py-2 rounded-lg mt-5" to={location.pathname}>x Reset alle filters</Link>
    </p>



    {/* <h4 className="font-oswald uppercase mt-2">Zoek per seizoen</h4>
    <ul className="font-inter list-none">
          <li>
            <label className="flex items-center -ml-4">
            <input 
                type="checkbox" 
                className="cursor-pointer"
                onChange={() => handleCheckboxChange('/surfvakanties/lente')} 
              />
                <Link to="/lente" className="mx-2 hover:cursor-pointer hover:underline ">Lente</Link>
              </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
              <input 
                type="checkbox" 
                className="cursor-pointer"
                onChange={() => handleCheckboxChange('/surfvakanties/zomer')} 
              />
                <Link to="/zomer" className="mx-2 hover:cursor-pointer hover:underline ">Zomer</Link>
              </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
            <input 
                type="checkbox" 
                className="cursor-pointer"
                onChange={() => handleCheckboxChange('/surfvakanties/herfst')} 
              />                
              <Link to="/surfvakanties/herfst" className="mx-2 hover:cursor-pointer hover:underline">Herfst</Link>
              </label>
            </li>
         

            <li>
            <label className="flex items-center -ml-4">
            <input 
                type="checkbox" 
                className="cursor-pointer"
                onChange={() => handleCheckboxChange('/surfvakanties/winter')} 
              />
                <Link to="/surfvakanties/winter" className="mx-2 hover:cursor-pointer hover:underline ">Winter</Link>
              </label>
            </li>
                     
        </ul>  */}
    </div>




    

      <div className="lg:w-3/4 w-full">
      <h1 className="text-4xl">Surfvakanties Peniche &amp; Baleal, Portugal</h1>

        <p className="font-inter mt-3 mb-5">
        Peniche, gelegen aan de westkust van Portugal, is een prachtige kustplaats die de harten van surfers van over de hele wereld heeft veroverd. Met zijn ruige kliffen, uitgestrekte zandstranden en een relaxte sfeer, is Peniche een ware oase voor wie op zoek is naar een onvergetelijke surfvakantie met SurfaWhile Portugal.
        </p>
       
       {/* Tweede paragraaf, alleen zichtbaar als isVisible true is */}
      {isVisible && (
        <p className="font-inter mt-3 mb-1">
          Bij SurfaWhile vind je een uitgebreide selectie aan surfvakanties die zorgvuldig zijn geselecteerd. Of je nu een beginner bent of een ervaren surfer, wij hebben de <b>perfecte surfvakantie voor jou</b>.
        </p>
      )}

      {/* Button voor het tonen of verbergen van de tweede paragraaf */}
      <span
        onClick={toggleVisibility}
        className="text-slate-900 font-inter font-semibold cursor-pointer block mb-3 hover:underline"
      >
        {isVisible ? "Lees minder -" : "Lees meer + "}
      </span>

<div className="flex justify-start inline lg:hidden">
      <button className="bg-black font-inter rounded-full text-white font-bold w-full py-2 px-5 z-10" onClick={() => setModalOpen(true)}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 inline mx-2 -mt-1">
  <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
</svg>
 Filters
 </button>
</div>
    
    <span className="font-inter font-semibold">{filteredAndSortedNodes.length} surfvakanties voldoen aan jouw criteria.</span>


    <div className="grid gap-4 md:grid-cols-2 grid-cols-1 grid-rows-">
  
    {filteredAndSortedNodes.map(({ node }) => (
      <div
      key={node.uri}
      className={`card grid-item bg-white rounded-xl m-2 pb-2 relative hover:shadow-md transition duration-300 ${node.surfvakantieNieuw.typeAccommodatie} ${node.surfvakantieNieuw.land} ${node.surfvakantieNieuw.categories.join(' ')} show-grid-item`}
    >
        <Link to={node.uri}>

        <img 
        src={node.featuredImage.node.publicUrl}
        alt={node.featuredImage.node.altText || "Featured image"}
      />
          

{/* <Swiper
  spaceBetween={50}
  slidesPerView={1}
  pagination={{ dynamicBullets: true }}
  navigation={{ clickable: true }} 
  modules={[Pagination, Navigation]}
>
  {/* Voeg de featured image toe als eerste afbeelding */}
{/*   
  {node.featuredImage && node.featuredImage.node && (
    <SwiperSlide key="featured-image" onClick={(e) => {
      e.stopPropagation();
      navigate(node.uri);
    }}> */}
      {/* <img 
        src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(node.featuredImage.node.sourceUrl)}`}
        alt={node.featuredImage.node.altText || "Featured image"}
      /> */}

{/* <img 
        src={node.featuredImage.node.publicUrl}
        alt={node.featuredImage.node.altText || "Featured image"}
      />
    </SwiperSlide>
  )} */}

  {/* Voeg de afbeeldingen uit de gallery toe */}
  {/* {node.surfvakantieNieuw.gallery.slice(0, 4).map((image, index) => (
    <SwiperSlide key={`gallery-image-${index}`} onClick={(e) => {
      e.stopPropagation();
      navigate(node.uri);
    }}>
      <img 
        src={image.sourceUrl}
        alt={image.altText || `Gallery Image ${index + 1} of ${node.title}`}
      />
    </SwiperSlide>
  ))}
</Swiper>  */}


<div className="flex justify-between absolute top-0 w-full">

  {/* {node.surfvakantieNieuw.hurryShout} */}
  {node.surfvakantieNieuw.hurryShout && (
            <div className="bg-sky-50 font-inter px-2 py-1 m-1 rounded-lg z-10 inline text-sm">
              <p className="font-inter font-semibold inline">{node.surfvakantieNieuw.hurryShout}</p>
            </div>
          )}

          {/* Conditional rendering of the "Kortingsactie" div */}
          {node.surfvakantieNieuw.discount && (
            <div className="bg-orange-500 font-inter px-2 py-1 text-white m-1 rounded-lg z-10 text-sm">
              <p className="font-inter font-semibold inline">Kortingsactie</p>
            </div>
          )}  


          </div>

  

          <div className="m-4">
            
            <div className="mt-2 -mb-2 text-xs font-inter text-slate-500 uppercase font-semibold flex justify-between">
              <div>{node.surfvakantieNieuw.typeAccommodatie} {node.surfvakantieNieuw.land}</div>
            
              {node.surfvakantieNieuw.rating !== null && !isNaN(node.surfvakantieNieuw.rating) && (
                  <div>
                <p className="ml-4 text-sm font-semibold text-slate-500">
                  <svg aria-hidden="true" className="w-5 h-5 text-yellow-400 inline -mt-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <title>Rating star</title>
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                    ></path>
                  </svg>
                  {node.surfvakantieNieuw.rating} / 5
                </p>
              </div>
              )}
            </div>

            <h4 className="text-lg font-inter font-semibold mb-2">{node.title}</h4>
            <ul className="list-none font-inter text-xs md:text-sm">
              <li className="flex items-center my-1">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5 -ml-6 inline text-slate-500">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>

                <p className="ml-4 text-slate-500 text-xs md:text-sm">
                  {node.surfvakantieNieuw.inleidingLocatie}, {node.surfvakantieNieuw.inleidingRegio}
                </p>
              </li>


              <li className="flex items-center justify-between my-1 w-full">
                <div className="text-slate-500 text-xs md:text-sm">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 -ml-6 align-top inline">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
              </svg>

                  <p className="ml-4 inline">{node.surfvakantieNieuw.inleidingMinimumleeftijd}</p>
                </div>
              </li>

              <li className="flex items-center justify-between my-1 w-full">
                <div className="text-slate-500 text-xs md:text-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 -ml-6 align-top inline">
                    <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
                  </svg>

                  <p className="ml-4 inline">{node.surfvakantieNieuw.populair}</p>
                </div>
              </li>


              <li className="flex items-center justify-between my-1 w-full">
                <div className="text-slate-500 text-xs md:text-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 -ml-6 -mt- inline">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
                  </svg>

                  <p className="ml-4 inline">{node.surfvakantieNieuw.inleidingOpen}</p>
                </div>
              </li>

              <li className="flex items-center justify-between my-1 w-full">
                <div className="text-slate-500 text-xs md:text-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 -ml-6 -mt- inline">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>

                  <p className="ml-4 inline">{node.surfvakantieNieuw.extra}</p>
                </div>
              </li>


              <li className="flex items-center justify-between my-1 w-full">
                <div className="text-slate-500 text-xs md:text-sm">
                <svg data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="w-5 h-5 -ml-6 -mt- inline">
  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"></path>
</svg>
                  <p className="ml-4 inline">{node.surfvakantieNieuw.inleidingVervoer}</p>
                </div>
              </li>

              <li className="flex items-center flex justify-end">
                <button className="bg-black text-white font-semibold py-2 px-4 rounded-lg float-right mt-3">Ontdek v.a. € {node.surfvakantieNieuw.inleidingPrijs},-</button>
              </li>
            </ul>
          </div>
        </Link>
      </div>
    ))}
</div>
    </div>
</div>









<div className="font-inter mx-auto p-2">

<div className="flex flex-col lg:flex-row my-3">
  <div className="lg:w-1/3 w-full">
    <h2 className="text-3xl">Peniche als surfparadijs</h2>
  </div>


  <div className="lg:w-2/3 w-full">
    <div className="font-inter leading-7">
        <h3 className="text-2xl my-3">Over Surfen rondom Peniche</h3>
        <p>Peniche heeft zichzelf stevig op de kaart gezet als een van de meest gewilde bestemmingen voor surfvakanties. En terecht! De indrukwekkende Atlantische golven die tegen de kust slaan, gecombineerd met de consistente branding, maken dit tot een waar surfersparadijs. Of je nu een beginnende surfer bent die zijn eerste golven wil bedwingen of een doorgewinterde pro op zoek naar de ultieme uitdaging, Peniche heeft voor ieder wat wils.</p>
        <p>Het scala aan surfspots is binnen handbereik. Supertubos, met zijn holle golven, is beroemd bij ervaren surfers, terwijl Baleal Beach ideaal is voor beginners. Met een gunstig klimaat en watertemperaturen die zelfs in het najaar en de winter aangenaam zijn, is Peniche het hele jaar door de perfecte bestemming voor surfliefhebbers.</p>
        <p>Naast de fantastische branding biedt Peniche ook een charmante en ontspannen sfeer die typisch is voor Portugese kustplaatsen. Na een dag op de golven kun je genieten van heerlijke zeevruchten in de gezellige restaurants van Peniche en de dag afsluiten met een prachtige zonsondergang.</p>
 

        <h3 className="text-2xl my-3">Surfen in het najaar in Peniche</h3>
      <p>Terwijl veel andere bestemmingen in deze tijd van het jaar kouder worden, blijft Peniche gezegend met milde temperaturen en een consistente branding. De herfst brengt de beste golven van het jaar, perfect voor zowel beginnende als ervaren surfers. Met minder drukte op de stranden en sfeervolle avonden in de lokale restaurants, biedt het najaar in Peniche de ideale setting voor een onvergetelijke surfvakantie.</p>
      
      <h3 className="text-2xl my-3">Beste Surfspots bij Peniche</h3>
      <p>Ontdek de beste surfvakanties rond Peniche met SurfaWhile, waaronder:</p>
      

      <h4 className="text-xl my-3">Supertubos</h4>  
      <h4 className="text-xl my-3">Baleal</h4>  
      <h4 className="text-xl my-3">Consolação</h4>
      <h4 className="text-xl my-3">Molhe Leste</h4>
      <h4 className="text-xl my-3">Almagreira</h4>

      <h3 className="text-2xl my-3">Reistips surfvakanties Peniche</h3>
      <p>Deze schilderachtige kustplaats in Portugal, huisvest ongeveer 28.000 inwoners. Maar het is niet alleen de lokale bevolking die deze plek speciaal maakt. Een hoogtepunt in de surfkalender is de Rip Curl Pro Portugal, een prestigieuze surfcompetitie die jaarlijks in Peniche wordt gehouden. Dit evenement trekt 's werelds beste surfers aan en biedt een geweldige kans om de sport op zijn best te zien. Deze vindt meestal plaats rond de maand oktober.</p>
      <p>Voor degenen die niet willen surfen, zijn er talloze prachtige stranden om te ontspannen, zoals Praia da Consolação en Praia da Areia Branca. Hier kun je genieten van de zon, zwemmen in de verfrissende Atlantische Oceaan of gewoon luieren op het zachte zand.</p>
      <p>De ideale reistijd voor Peniche is het najaar, wanneer de temperaturen nog steeds aangenaam zijn, variërend van 18°C tot 25°C. De zee blijft warm genoeg om comfortabel in te surfen, terwijl de drukte van de zomer is afgenomen, wat zorgt voor een meer ontspannen ervaring.</p>
      <p>En als het op eten en drinken aankomt, heeft Peniche zeker wat te bieden. Mahara Indian Food is een absolute must-visit, waar je kunt genieten van heerlijke Indiase gerechten. Bar Trest As is een gezellig café bij de haven voor een verfrissend biertje. Voor authentieke Portugese gerechten zonder de bank te breken, is Cantinho do Bolha een geweldige budgetoptie.</p>

      <h3 className="text-2xl my-3">Praktische informatie</h3>
      <p>Reizen naar Peniche is vrij eenvoudig, en hier is wat praktische informatie om je op weg te helpen. Vanuit Nederland kun je naar Peniche vliegen door naar de luchthaven van Lissabon te gaan, dat op ongeveer 80 kilometer van Peniche ligt. De vliegtijd van Nederland naar Lissabon bedraagt doorgaans ongeveer 3 tot 3,5 uur, afhankelijk van de luchthaven van vertrek en de vluchtroute.</p>
      <p>Vanaf de luchthaven van Lissabon kun je op verschillende manieren naar Peniche reizen. Een populaire optie is het huren van een auto, waarmee je de vrijheid hebt om op je eigen tempo te reizen en de prachtige kustlijn van Portugal te verkennen. Het rijden van Lissabon naar Peniche duurt ongeveer 1 tot 1,5 uur, afhankelijk van het verkeer.</p>
      <p>Een andere optie is om gebruik te maken van het uitgebreide openbaar vervoersnetwerk in Portugal. Je kunt een trein nemen vanaf het treinstation Oriente in Lissabon naar het treinstation in Caldas da Rainha, en van daaruit kun je een bus nemen naar Peniche. Deze reis duurt wat langer dan met de auto, maar het is een milieuvriendelijke en betaalbare optie.</p>
      <p>Wat betreft de voertaal, is Portugees de officiële taal in Peniche en Portugal. Echter, in toeristische gebieden, waaronder Peniche, kun je meestal goed uit de voeten met Engels.</p>

      <p>Bekijk alle <Link to="/surfvakanties/portugal">surfvakanties in Portugal</Link>  met SurfaWhile.</p>


</div>
  </div>

  </div>
  </div>
</div>
</div>


  


        
    <Modal
isOpen={modalOpen}
onRequestClose={() => setModalOpen(false)}
style={{ overlay: { zIndex: 50 } }}  // Add this line
className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-white"
>


<div id="mobile-filters" className="w-full h-full flex justify-end">

<div className="w-full px-4 pt-4">

<Link className="font-inter ml-2 mb-1 font-semibold text-md hover:underline bg-stone-100 text-black px-5 py-2 rounded-lg mt-5" to={location.pathname}>x Reset alle filters</Link>

      <div className="mx-auto w-full max-w-md rounded-2xl p-2">
      
        
        <Disclosure as="div" className="mt-2">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-100 px-4 py-2 text-left text-md font-medium text-slate-900 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
              <h4 className="font-oswald uppercase font-bold mt-2">Doelgroep</h4>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-7 w-7 mt-1 text-black font-bold`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4 text-sm text-gray-500">
              <ul className="font-inter list-none">
          <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("adults")}
          onChange={() => handleCatCheckboxChange("adults")}
        />
        <span className="ml-2 font-semibold">Volwassenen</span>
        </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("family")}
          onChange={() => handleCatCheckboxChange("family")}
        />
        <span className="ml-2 font-semibold">Families</span>
        </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("juniors")}
          onChange={() => handleCatCheckboxChange("juniors")}
        />
        <span className="ml-2 font-semibold">Jongeren</span>
        </label>
            </li>
               
        </ul>
        </Disclosure.Panel>
            </>
          )}
        </Disclosure>




        <Disclosure as="div" className="mt-2">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-100 px-4 py-2 text-left text-md font-medium text-slate-900 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
              <h4 className="font-oswald uppercase font-bold mt-2">Type reiziger</h4>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-7 w-7 mt-1 text-black font-bold`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4 text-sm text-gray-500">
              <ul className="font-inter list-none">
          <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("solo")}
          onChange={() => handleTypeCheckboxChange("solo")}
        />
        <span className="ml-2 font-semibold">Solo-Reizigers</span>
        </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("friends")}
          onChange={() => handleTypeCheckboxChange("friends")}
        />
        <span className="ml-2 font-semibold">Vrienden/vriendinnen</span>
        </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("couple")}
          onChange={() => handleTypeCheckboxChange("couple")}
        />
        <span className="ml-2 font-semibold">Koppels</span>
        </label>
            </li>
         
                     
        </ul>
        </Disclosure.Panel>
            </>
          )}
        </Disclosure>



        <Disclosure as="div" className="mt-2">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-100 px-4 py-2 text-left text-md font-medium text-slate-900 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
              <h4 className="font-oswald uppercase font-bold mt-2">Seizoen</h4>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-7 w-7 mt-1 text-black font-bold`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4 text-md text-gray-500">
              <ul className="font-inter list-none">


            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("spring")}
          onChange={() => handleSeasonCheckboxChange("spring")}
        />
        <span className="ml-2 font-semibold">Voorjaar</span>
        </label>
            </li>

            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("summer")}
          onChange={() => handleSeasonCheckboxChange("summer")}
        />
        <span className="ml-2 font-semibold">Zomer</span>
        </label>
            </li>


            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("autumn")}
          onChange={() => handleSeasonCheckboxChange("autumn")}
        />
        <span className="ml-2 font-semibold">Herfst</span>
        </label>
            </li>


            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("winter")}
          onChange={() => handleSeasonCheckboxChange("winter")}
        />
        <span className="ml-2 font-semibold">Winter</span>
        </label>
            </li>
         
                     
        </ul>
        </Disclosure.Panel>
            </>
          )}
        </Disclosure>




        <Disclosure as="div" className="mt-2">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-100 px-4 py-2 text-left text-sm font-medium text-slate-900 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
              <h4 className="font-oswald uppercase font-bold mt-2">Thema</h4>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-7 w-7 mt-1 text-black font-bold`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4 text-md text-gray-500">
              <ul className="font-inter list-none">


            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("yoga")}
          onChange={() => handleThemeCheckboxChange("yoga")}
        />
        <span className="ml-2 font-semibold">Surf &amp; Yoga</span>
        </label>
            </li>

            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("language")}
          onChange={() => handleThemeCheckboxChange("language")}
        />
        <span className="ml-2 font-semibold">Surf &amp; Taal</span>
        </label>
            </li>


            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("bus")}
          onChange={() => handleThemeCheckboxChange("bus")}
        />
        <span className="ml-2 font-semibold">Busreizen</span>
        </label>
            </li>


            <li>
            <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("kite")}
          onChange={() => handleThemeCheckboxChange("kite")}
        />
        <span className="ml-2 font-semibold">Kitesurfen</span>
        </label>
            </li>


            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("coworking")}
          onChange={() => handleThemeCheckboxChange("coworking")}
        />
        <span className="ml-2 font-semibold">Coworking</span>
        </label>
            </li>

            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("glamping")}
          onChange={() => handleThemeCheckboxChange("glamping")}
        />
        <span className="ml-2 font-semibold">Glamping</span>
        </label>
            </li>

            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("surfcamp")}
          onChange={() => handleThemeCheckboxChange("surfcamp")}
        />
        <span className="ml-2 font-semibold">Surfcamp</span>
        </label>
            </li>

            <li>
          <label className="flex items-center -ml-4">
        <input
          type="checkbox"
          checked={location.search.includes("surflodge")}
          onChange={() => handleThemeCheckboxChange("surflodge")}
        />
        <span className="ml-2 font-semibold">Surflodge</span>
        </label>
            </li>
         
                     
        </ul>
        </Disclosure.Panel>
            </>
          )}
        </Disclosure>



        <div className="fixed bottom-10 flex justify-center inline lg:hidden">
      <button className="bg-black font-inter rounded-full text-white font-bold w-64 py-2 px-5 z-10" onClick={() => setModalOpen(false)}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 inline mx-2 -mt-1">
  <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
</svg>
 Naar {filteredAndSortedNodes.length} resultaten
 </button>
    </div>
      
      
      </div>
    </div>
</div>


</Modal>  

      </Layout>
    )
  }

export const Query = graphql`
query {
  allWpSurfvakantie(
    filter: {
      surfvakantieNieuw: {
        inleidingLocatie: { in: ["Baleal (Peniche)"] }
        categories: { nin: ["group"] }} 

      language: { code: { eq: NL }}
    }
  ) { 
    edges {
      node {
        uri
        title
        surfvakantieNieuw {
          land
              inleidingLocatie
              inleidingRegio
              inleidingOpen
              inleidingVervoer
              rating
              categories
              typeAccommodatie
              customOrder
              discount
              hurryShout
              populair
              extra
              inleidingVervoer
              inleidingMinimumleeftijd
              inleidingPrijs
              gallery {
                publicUrl
                id
                localFile {
                  id
                  childImageSharp {
                    gatsbyImageData(
                      width: 900
                      height: 600
                      placeholder: BLURRED
                      formats: [AUTO, WEBP, AVIF]
                      layout: CONSTRAINED
                    )
                  }
                }
            }
        }
        featuredImage {
          node {
            publicUrl
            uri
            localFile {
              id
              childImageSharp {
                gatsbyImageData(
                 height: 400
                 width: 600
                 placeholder: BLURRED
                 formats: [AUTO, WEBP, AVIF]
                 )
              }
            }
          }
        }
      }
    }
  }
  wpSurfvakantie(databaseId: {eq: 40847}) {
    title
        seo {
        title
        metaDesc
        }
      listPagesSurfvakanties {
        introText {
          introTextOne
          introTextTwo
        }
        overSurfenInBestemming
        praktischeInformatie
        surfseizoenen
        besteSurfspots
        transport
    }
  }
  }`



